import { GetSubjectsRoutine } from '~modules/Subject/redux-routines';

export const initialState = {
  data: [],
  error: null,
  isFetching: false,
};

export const subjectsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetSubjectsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GetSubjectsRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      };
    }
    case GetSubjectsRoutine.FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };

    default:
      return state;
  }
};
